import zip from 'lodash/zip';
import truncate from 'lodash/truncate';

import { connect } from 'react-redux';

import { getSelectedSample } from 'store/scenes/randomizationHypothesisTesting/samples/selectors';
import { getPrimaryParameter } from 'store/scenes/randomizationHypothesisTesting/primaryParameter/selectors';
import { getSecondaryParameter } from 'store/scenes/randomizationHypothesisTesting/secondaryParameter/selectors';

import NumericalComponent from './Component';

const mapStateToProps = state => {
  const primaryParameter = getPrimaryParameter(state);
  const secondaryParameter = getSecondaryParameter(state);

  return ({
    primaryParameterName: truncate(primaryParameter.name, { length: 15 }),
    secondaryParameterName: truncate(secondaryParameter.name, { length: 15 }),

    sampleDots: getSelectedSample(state),

    datasetDots: zip(
      primaryParameter.values,
      secondaryParameter.values
    )
  });
};

export default connect(mapStateToProps)(NumericalComponent);
